import React from 'react';
import {
  Box,
  Container,
  Flex,
  Heading,
  Icon,
  Link,
  HStack,
  IconButton,
  useColorMode
} from '@chakra-ui/react';
import { FiNavigation, FiGithub, FiMoon, FiSun } from 'react-icons/fi';
import { Link as RouterLink } from 'react-router-dom';

const ACCENT_RGB = 'var(--chakra-colors-brand-primary-rgb)';

const Header = () => {
  const { colorMode, toggleColorMode } = useColorMode();

  const iconButtonStyles = {
    variant: 'ghost' as const,
    size: 'md' as const,
    color: 'text.muted',
    _hover: {
      bg: `rgba(${ACCENT_RGB}, 0.10)`,
      color: 'brand.primary',
    },
  };

  return (
    <Box
      as="header"
      py={3}
      px={6}
      backdropFilter="blur(12px)"
      backgroundColor="bg.canvas.translucent"
      position="sticky"
      top={0}
      zIndex={10}
      borderBottom="1px solid"
      borderColor="border.subtle"
    >
      <Container maxW="container.xl">
        <Flex justify="space-between" align="center">
          <Link as={RouterLink} to="/" _hover={{ textDecoration: 'none' }}>
            <HStack spacing={3}>
              {/* Icon pill badge */}
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                w={8}
                h={8}
                borderRadius="8px"
                bg="brand.primary"
              >
                <Icon as={FiNavigation} w={4} h={4} color="white" />
              </Box>
              <HStack spacing={1} fontFamily="'Space Grotesk', sans-serif" fontWeight="700" fontSize="md">
                <Heading size="md" fontWeight="700" letterSpacing="-0.02em">GPX</Heading>
                <Heading
                  size="md"
                  fontWeight="400"
                  color="brand.primary"
                  letterSpacing="-0.01em"
                >
                  →
                </Heading>
                <Heading size="md" fontWeight="700" letterSpacing="-0.02em">KML</Heading>
              </HStack>
            </HStack>
          </Link>
          <HStack spacing={2}>
            <Link href="https://github.com/dmeuwissen" isExternal>
              <IconButton
                aria-label="GitHub"
                icon={<FiGithub />}
                {...iconButtonStyles}
              />
            </Link>
            <IconButton
              aria-label={`Switch to ${colorMode === 'light' ? 'dark' : 'light'} mode`}
              icon={colorMode === 'light' ? <FiMoon /> : <FiSun />}
              onClick={toggleColorMode}
              {...iconButtonStyles}
            />
          </HStack>
        </Flex>
      </Container>
    </Box>
  );
};

export default Header;
